import { useMutation } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

export function useGetPlanejamentoOperacionalId() {
  return useMutation(URL.PLANO_OPERACIONAL.OBTER_BY_ID('id'), async (id: string) => {
    const response = await http.get(URL.PLANO_OPERACIONAL.OBTER_BY_ID(id));
    return response;
  });
}


